import { StyleProps } from '@summer/jst-react';
import qr, { QRCodeRenderersOptions } from 'qrcode';
import { useEffect, useRef } from 'react';

export interface QRCodeProps extends QRCodeRenderersOptions {
  value: string;
}

export const QRCode = ({
  value,
  margin = 0,
  width = 250,
  style,
  className,
  ...props
}: QRCodeProps & StyleProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    qr.toCanvas(canvasRef.current, value, { margin, width, ...props });
  }, [value, margin, width, props]);

  return <canvas ref={canvasRef} style={style} className={className} />;
};
